module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_function-to-string.js
// module id = 400
// module chunks = 14